import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { captureException } from '@fttb/common/components';
import { checkHouseConnection } from '@fttb/common';
import { sendVkCheckAddressEventAnalytics } from "../../../../blocks/analytics";
import { getQueryParams } from "../../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/utils/utils";
import { ERROR_TYPES } from "../../../constants";
import { mapCheckConnectionResponse } from "../utils";
import { getSelectedAddress } from "../moduleSelectors";
import { getTariffsByColor } from "../../../checkAddress/actions";
import { AVAILABLE_STATUSES } from "../../../checkAddress/constants";
import { setHouseInacId } from "../../../../components/OrderTariffFormPopup/OrderTariffFormInlinePopup/store/slice";
export var checkConnectionAndTariffs = createAsyncThunk('addressVerification/checkConnectionAndTariffs', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var dispatch, getState, rejectWithValue, state, address, houseFiasId, settlementFiasId, cityFiasId, regionFiasId, streetWithType, house, flat, block, blockType, result, _ref3, redirectInfo, highSpeedAvailable, connectionState, houseColor, houseInacId, connectionStatus, queryParams, currentPath, newUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          state = getState();
          address = getSelectedAddress(state);
          if (!(!address || !address.flat)) {
            _context.next = 6;
            break;
          }
          throw new Error(ERROR_TYPES.emptyAddress);
        case 6:
          houseFiasId = address.house_fias_id, settlementFiasId = address.settlement_fias_id, cityFiasId = address.city_fias_id, regionFiasId = address.region_fias_id, streetWithType = address.street_with_type, house = address.house, flat = address.flat, block = address.block, blockType = address.block_type;
          _context.next = 9;
          return checkHouseConnection({
            houseFiasId: houseFiasId,
            settlementFiasId: settlementFiasId,
            regionFiasId: regionFiasId,
            streetWithType: streetWithType,
            cityFiasId: cityFiasId,
            house: house,
            flat: flat,
            block: block,
            blockType: blockType
          });
        case 9:
          result = _context.sent;
          _ref3 = result || {}, redirectInfo = _ref3.redirectInfo, highSpeedAvailable = _ref3.highSpeedAvailable, connectionState = _ref3.connectionState, houseColor = _ref3.houseColor, houseInacId = _ref3.houseInacId;
          connectionStatus = mapCheckConnectionResponse({
            status: connectionState,
            isHighSpeed: highSpeedAvailable
          });
          dispatch(setHouseInacId(houseInacId));
          if (redirectInfo !== null && redirectInfo !== void 0 && redirectInfo.isNeedRedirect && redirectInfo !== null && redirectInfo !== void 0 && redirectInfo.redirectUrl) {
            /** для инициализации введенного адреса после редиректа собираем урл-строку */
            queryParams = getQueryParams(address);
            currentPath = window.location.pathname;
            newUrl = "".concat(redirectInfo.redirectUrl).concat(currentPath, "?").concat(queryParams);
            window.location.replace(newUrl);
          }
          if (AVAILABLE_STATUSES.includes(connectionStatus)) {
            sendVkCheckAddressEventAnalytics(true);
            // eslint-disable-next-line no-void
            void dispatch(getTariffsByColor({
              isHighSpeedAvailable: highSpeedAvailable,
              houseColor: houseColor
            }));
          } else {
            sendVkCheckAddressEventAnalytics(false);
          }
          return _context.abrupt("return", {
            isRedirect: redirectInfo === null || redirectInfo === void 0 ? void 0 : redirectInfo.isNeedRedirect,
            connectionStatus: connectionStatus,
            houseInacId: houseInacId
          });
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
          captureException(_context.t0);
          if (!(_context.t0 instanceof Error)) {
            _context.next = 23;
            break;
          }
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 23:
          throw new Error();
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 18]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());